import { ComponentType } from 'react';
import { DirectionsList } from './directions-list';

export const Directions: ComponentType = () => {
  return <DirectionsList />;
};
